module.exports = __webpack_public_path__ + "media/customizations/fccsa/back-e503652077369fdfcb64452f2c32615e.jpg";